module.exports = __webpack_public_path__ + "images/16_5dd998f9.jpg";